import React from 'react';
import { GoogleLogin, CredentialResponse } from '@react-oauth/google';
import { API_BASE_URL, GOOGLE_CLIENT_ID } from '../../config';

interface GoogleSsoButtonProps {
  text: 'signin_with' | 'signup_with';
  intent: 'login' | 'register';
  width?: string;
  onSuccess: (token: string) => void;
  onError: (message: string, code?: string) => void;
}

const GoogleSsoButton: React.FC<GoogleSsoButtonProps> = ({ text, intent, width = '384', onSuccess, onError }) => {
  if (!GOOGLE_CLIENT_ID) {
    return null;
  }

  const handleSuccess = async (credentialResponse: CredentialResponse) => {
    if (!credentialResponse.credential) {
      onError('Google sign-in did not return a credential');
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/auth/google`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ credential: credentialResponse.credential, intent }),
      });

      const data = await response.json();

      if (!response.ok) {
        onError(data.message || 'Google sign-in failed', data.code);
        return;
      }

      onSuccess(data.token);
    } catch (error) {
      onError('An error occurred during Google sign-in');
    }
  };

  return (
    <div className="flex justify-center">
      <GoogleLogin
        onSuccess={handleSuccess}
        onError={() => onError('Google sign-in failed')}
        text={text}
        width={width}
      />
    </div>
  );
};

export default GoogleSsoButton;
